var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"talkview compare-face-box"},[_c('ul',{staticClass:"compare-face-ul"},[_c('li',[_c('p',[_vm._v("监考流程图")]),_c('el-image',{staticClass:"img",attrs:{"fit":"contain","src":_vm.invigilationPicUrl,"preview-src-list":[_vm.invigilationPicUrl]}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }